<template>
  <v-container>
    <uploaded-details v-model="detailsDialog" :uploaded="selectedUploaded" :product="selectedProduct"
                      @reload="this.closeDialog" :key="uploadedDetailsKey"
                      @close="this.closeDialog"/>
    <upload-delete-confirmation v-model="this.showDeleteConfirmation"
                              :key="`delete_${this.selectedUploaded ? this.selectedUploaded.id : -2}`"
                              :uploaded="this.selectedUploaded"
                              @delete="this.reallyDeleteUploaded"
                              @close="this.closeDeleteConfirmation">

    </upload-delete-confirmation>

    <h4 class="align-left pa-2 section-title">{{ currentRouteName }}</h4>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
                :items="products"
                label="Produkt"
                v-model="selectedProduct"
                item-text="name"
                item-value="id"
                v-on:change="productChanged"
                persistent-hint
                return-object
                outlined
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-btn
                @click="createUploaded"
                color="primary"
            >
              + Neuer Upload
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
              :headers="headers"
              :items="uploadedList ? uploadedList : []"
              :loading="[undefined, null].includes(uploadedList)"
              loading-text="Daten werden geladen .. Bitte warten"
              class="elevation-1"
              :options="tableOptions"
              mobile-breakpoint="0"
      >
        <template v-slot:item="row">
          <uploaded-row :uploaded="row.item"
                        @edit="editUploaded"
                        @delete="deleteUploaded"/>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
  import productsApi from '../api/products'
  import UploadedRow from '../components/UploadedRow'
  import uploadedApi from '../api/uploaded'
  import UploadedDetails from './UploadedDetails'
  import UploadDeleteConfirmation from "@/components/UploadDeleteConfirmation";
  import ErrorStore from "@/stores/ErrorStore";
  import ProductStore from "@/stores/ProductStore";
  import RouteInfo from "@/utils/RouteInfo";
  import SortUtil from "@/utils/sortUitl";

  export default {
    extends: RouteInfo,
    name: 'DataUpload',
    components: {UploadDeleteConfirmation, UploadedRow, UploadedDetails},
    data: () => {
      return {
        products: [],
        uploadedList: [],
        detailsDialog: false,
        selectedUploaded: null,
        selectedProduct: ProductStore.getProduct(),
        tableOptions: {
          itemsPerPage: 10
        },
        showDeleteConfirmation: false,
        headers: [
          { text: 'Datum', value:'upload_date', align: 'left' },
          { text: 'Uploadname', value: '', align: 'left' },
          { text: 'Content-Type', value: 'content_type', align: 'left' },
          { text: 'Kodierung', value: 'encoding', align: 'left' },
          { text: 'Aktiv', value: 'active', align: 'left' },
          { text: 'Optionen', value: '', align: 'right' }
        ]
      }
    },
    mounted() {
      this.fetchProducts()
    },
    computed: {
      uploadedDetailsKey () {
        return this.selectedProduct ? `${this.selectedProduct.id}_${this.selectedUploaded ? this.selectedUploaded.id : -1}` : -1
      }
    },
    methods: {
      fetchProducts () {
        productsApi.getProducts().then((r) => {
          this.products = SortUtil.sortedNames(r.data)
          this.selectedProduct = ProductStore.getProduct() ? ProductStore.getProduct() : this.products[0]
          if(!ProductStore.getProduct()) {
            ProductStore.setProduct(this.products[0])
          }
          this.fetchUploaded()
        })
      },
      fetchUploaded () {
        ProductStore.setProduct(this.selectedProduct)
        this.uploadedList = null
        uploadedApi.getAllUploaded(this.selectedProduct.id).then((res) => {
          this.uploadedList = res.data
        }).catch((error) => {
          if (error.response && error.response.data) {
            console.log('error', error.response.data)
          }
        })
      },
      productChanged () {
        this.uploadedList = []
        this.fetchUploaded()
      },
      editUploaded (endpoint) {
        this.selectedUploaded = endpoint
        this.detailsDialog = true
      },
      deleteUploaded (endpoint) {
        this.selectedUploaded = endpoint
        this.showDeleteConfirmation = true
      },
      closeDialog () {
        this.detailsDialog = false
        this.selectedUploaded = null
        this.fetchUploaded()
      },
      createUploaded () {
        this.detailsDialog = true
      },
      reallyDeleteUploaded () {
        this.showDeleteConfirmation = false
        uploadedApi.deleteUploaded(this.selectedUploaded.id).then(r=> {
          ErrorStore.showErrorMessage('Der Upload-Endpunkt wurde gelöscht', 'Info')
          this.selectedUploaded = null
          this.fetchProducts()
        }).catch(e => {
          this.selectedUploaded = null
          if(e.response) {
            if (e.response.status === 400) {
              ErrorStore.showError(e.response.data)
            } else if(e.response.status === 403) {
              ErrorStore.showMessage('Sie haben keine Berechtigung, diesen Vorgang durchzuführen.', 'Fehler')
            }
          }
        })
      },
      closeDeleteConfirmation () {
        this.showDeleteConfirmation = false
        this.selectedUploaded = null
      }
    }
  }
</script>
